
import { WorldCountry } from './types';

export const unitedArabEmiratesData: WorldCountry = {
  code: 'AE',
  name: 'United Arab Emirates',
  slug: 'united-arab-emirates',
  population: 9890402,
  topCities: [
    { name: 'Dubai', slug: 'dubai', population: 3554000 },
    { name: 'Abu Dhabi', slug: 'abu-dhabi', population: 1807000 },
    { name: 'Sharjah', slug: 'sharjah', population: 1684649 },
    { name: 'Al Ain', slug: 'al-ain', population: 766936 },
    { name: 'Ajman', slug: 'ajman', population: 540923 },
    { name: 'Ras Al Khaimah', slug: 'ras-al-khaimah', population: 400000 },
    { name: 'Fujairah', slug: 'fujairah', population: 256000 },
    { name: 'Umm Al Quwain', slug: 'umm-al-quwain', population: 72000 },
    { name: 'Khor Fakkan', slug: 'khor-fakkan', population: 46000 },
    { name: 'Dibba Al-Fujairah', slug: 'dibba-al-fujairah', population: 41000 }
  ]
};
